module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/article01-71875325f860b8c5ae57360317c9513c.png";